export default __webpack_public_path__ + "static/2-38d67b88cda94a23f672301a0410672c.png";